import { useState } from 'react';

import useAlertQueue from 'hooks/useAlertQueue';
import Divider from 'storybookConfig/stories/molecules/Divider';
import Heading from 'storybookConfig/stories/molecules/Heading';
import Toggle from 'storybookConfig/stories/molecules/Toggle';
import { updateCompany } from 'utils/api/companies';
import PrimaryButton from 'storybookConfig/stories/molecules/Button/PrimaryButton';
import DSSpinner from 'storybookConfig/stories/molecules/Spinner';

const SyncingSettings = ({ company }) => {
  const { addSuccessAlert, addErrorAlert } = useAlertQueue();
  const [pending, setPending] = useState(false);
  const [syncUnpublishedProducts, setSyncUnpublishedProducts] = useState(
    company?.flags?.syncUnpublishedProducts ?? false
  );

  const onSubmit = (e) => {
    e.preventDefault();

    setPending(true);
    updateCompany(company._id, { flags: { syncUnpublishedProducts } }).then((response) => {
      setPending(false);
      if (response.error) {
        addErrorAlert(response.error.message);
        return;
      }
      addSuccessAlert('Sync settings updated');
    });
  };

  if (company.commerceType === 'buyer') {
    // Syncing settings are only available for sellers
    return null;
  }

  return (
    <div>
      <br />
      <Divider />
      <br />
      <Heading variant="Headings/H3">Syncing</Heading>
      <br />
      <form onSubmit={onSubmit}>
        <Toggle
          name="syncUnpublishedProducts"
          checked={syncUnpublishedProducts}
          onChange={(e) => setSyncUnpublishedProducts(e.target.checked)}
          description="By including unpublished products, you can make products available to your partners that are not published on your ecommerce platform."
        >
          Sync Unpublished Products
        </Toggle>
        <br />
        <br />
        <div className="d-flex">
          <PrimaryButton
            size="small"
            type="submit"
            disabled={pending || company.flags.syncUnpublishedProducts === syncUnpublishedProducts}
          >
            {pending ? <DSSpinner size="16px" color="bodyTextCaption" /> : 'Save Sync Settings'}
          </PrimaryButton>
        </div>
      </form>
    </div>
  );
};

export default SyncingSettings;
